import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/clients/$clientId')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: () => <Outlet />,
  staticData: { crumb: 'Client' },
});
